export default '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFDA44" d="M0 0h513v342H0z"/><path fill="#D80027" d="M0 256.5h513V342H0z"/><path fill="#0052B4" d="M0 171h513v85.5H0z"/></svg>'
